import { render, staticRenderFns } from "./HowToJoinView.vue?vue&type=template&id=79355deb&scoped=true&lang=html&"
import script from "./HowToJoinView.vue?vue&type=script&lang=js&"
export * from "./HowToJoinView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79355deb",
  null
  
)

export default component.exports